module.exports = __webpack_public_path__ + "media/reference_check/images/done_feedback_request_page-b756136311758d18de3016d3baa26e19.svg";